import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { LOCAL_STORAGE_KEYS } from "src/app/global/constants";
import { DataTransferService } from "./data-transfer.service";
import { LocalStorageService } from "./local-storage.service";
import { Socket, io } from "socket.io-client";

@Injectable({
  providedIn: "root",
})
export class SocketService {
  socket: Socket;

  constructor(
    private localStorage: LocalStorageService,
    private dataService: DataTransferService,
  ) {
    // if (!this.socket) {
    //   this.connectToSocket();
    // }
  }

  connectToSocket() {
    this.socket = io(`${environment.socketUrl}`, {
      path: "/api/conversation/socket/",
      transports: ["websocket"],
    });

    this.socket.on("connect", () => {
      const token = this.localStorage.getLocalStore(LOCAL_STORAGE_KEYS.TOKEN);

      if (token) {
        this.socket.emit("register", { to: this.socket.id, data: { token } });
        this.listenCurrencyEvent();
      }
    });
  }

  emitEvent(eventName: string, eventData: any) {
    this.socket.emit(eventName, eventData);
  }

  listenEvent(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data: any) => {
        subscriber.next(data);
      });
    });
  }

  stopListen(): void {
    this.socket.removeAllListeners();
  }

  disconnect(): void {
    this.socket.disconnect();
  }

  removeEventListeners(eventNames: string[]) {
    if (eventNames && eventNames.length) {
      eventNames.forEach((event) => {
        this.socket.removeListener(event);
      });
    }
  }

  listenCurrencyEvent() {
    this.listenEvent("epw-wallet").subscribe(async (data) => {
      const userId = (await this.localStorage.getDataFromIndexedDB(
        LOCAL_STORAGE_KEYS.ID,
      )) as number;
      if (data?.data && userId === data.data.userId) {
        this.dataService.walletUpdateSub.next(data.data);
        this.dataService.walletBalance = data.data.balance;
        await this.localStorage.setDataInIndexedDB(
          LOCAL_STORAGE_KEYS.WALLET_BALNCE,
          data.data.balance,
        );
      }
    });

    this.listenEvent("epw-currency").subscribe(async (data) => {
      // debugger
      // data
      // this.dataService.currencySymbol = data;
      // await this.localStorage.setDataInIndexedDB(LOCAL_STORAGE_KEYS.CURRENCY_SYMBOL, this.dataService.currencySymbol);
    });
  }
}
